import { AccountLimitTierResponse } from '../types';
import { getAccountLimitsUrl } from '../urls';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

/**
 * Return the account limit info
 * @param websiteId
 * @returns an property account limit
 */
async function getAccountLimits(websiteId: string): Promise<{
  accountLimit: AccountLimitTierResponse['accountLimit'];
}> {
  const client = HsmBackendHttpClient.instance;

  const { result } = await client.get<
    HsmBackendResponse<AccountLimitTierResponse>
  >(getAccountLimitsUrl(websiteId));

  return result;
}

export default getAccountLimits;
